//@import dependencies
import React, { useState, useEffect } from 'react'
import { useTranslation } from 'react-i18next'
//@end

//@import components
import IconComponent from 'app_components/commons/icons'
import ModalMediaComponent from 'app_components/commons/modalMedia'
//@end

// @import hooks
import {useColors} from 'app_hooks/useColors'
// @end

// @INFO Import types
import { IMediaData } from 'app_types/media/media.types';
// @end

// @INFO Import services
// @end

// @INFO Import Styles
import './../researchCardCommon.scss'

// @ADD Component types
interface IResearchCardCommonLayoutProps {
  cover: string,
  title: string
  subtitle: string
  authors?: Array<string>
  media?: IMediaData
  list?: string
}

const ResearchCardCommonLayout: React.FC<IResearchCardCommonLayoutProps> = (props) => {

  const [colors] = useColors()
  const { t } = useTranslation()
  const [openModal, updateOpenModal] = useState<boolean>(false)
  const [triggerClose, updateTriggerClose] = useState<any>({})

  useEffect(() => {
    updateOpenModal(false)
  },[triggerClose])

  /**
   * @INFO Cerrar el modal
   */
  const handleCloseModal = () => {
    updateTriggerClose({})
  }

  return(
    <div
      className={`research_card-component ${props.list ? 'list' : ''}`}
      onClick={props.media ? () => updateOpenModal(true) : undefined}
      style={{ cursor: props.media ? 'pointer' : undefined }}
    >
      {props.media ?
        <ModalMediaComponent
          media={props.media}
          open={openModal}
          showDescription
          showName
          onClose={handleCloseModal}
        />
      :null}
      <div className="research-card-image">
        <img src={props.cover} alt={`Imagen de ${props.title}`} />
        <button className="research-card-share">
          <IconComponent svg="ShareCircle" width="20" color={colors.secondary} />
        </button>
      </div>
      {props.authors && Array.isArray(props.authors) && props.authors.length > 0 ? (
        <div className="research-card-authors">{t('components.research_card.author')}: {props.authors.join(', ')}</div>
      ): (
        <div className="research-card-authors">{t('components.research_card.author')}: Icontec</div>
      )}
      <div className="research-card-title">{props.title}</div>
    </div>
  )
}

export default ResearchCardCommonLayout
